import React, { useState } from 'react'
import { AccountCustomWorkflowRunSummary, useListChildCustomWorkflowRunsQuery } from '../../../store/customWorkflow/customWorkflows'
import { Spinner } from '../../../components/Spinner/Spinner'
import { RunRowAction, WorkflowRunRow } from './WorkflowRunRow'
import { RunsPager } from './RunsPager'

const CHILD_PAGE_SIZE = 10

interface ChildRunsListProps {
  accountId: string
  parentRunId: string
  parentActive: boolean
  actionFor?: (run: AccountCustomWorkflowRunSummary) => RunRowAction | undefined
}

export const ChildRunsList: React.FC<ChildRunsListProps> = ({ accountId, parentRunId, parentActive, actionFor }) => {
  const [page, setPage] = useState(0)
  const { data, isLoading, isError } = useListChildCustomWorkflowRunsQuery(
    { accountId, parentRunId, page, size: CHILD_PAGE_SIZE },
    { skip: !accountId, pollingInterval: parentActive ? 10000 : 0, skipPollingIfUnfocused: true },
  )

  if (isLoading) {
    return (
      <div className='d-flex justify-content-center py-3 ps-4'>
        <Spinner size='sm' />
      </div>
    )
  }
  if (isError) {
    return <div className='py-2 ps-4 paragraph-small zocks-text-gray-600'>Could not load sub-runs.</div>
  }
  const runs = data?.data ?? []
  if (!runs.length) {
    return <div className='py-2 ps-4 paragraph-small zocks-text-gray-600'>No sub-runs.</div>
  }
  return (
    <div className='d-flex flex-column zocks-gap-2 ps-4'>
      {runs.map((run) => (
        <WorkflowRunRow key={run.id} run={run} action={actionFor?.(run)} />
      ))}
      <div className='d-flex justify-content-end'>
        <RunsPager page={page} totalPages={data?.page.totalPages ?? 0} onPageChange={setPage} />
      </div>
    </div>
  )
}
